module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltip":"The list presents a review of current availability in stores and an additional list of inaccessible products."}}')
  delete Component.options._Ctor
}
